import React from 'react';
import PropTypes from 'prop-types';

import Recommendations from 'Components/Product/Recommendations';
import useProductRecommendations from 'Components/Product/Hooks/useProductRecommendations';

const ProductRecommendations = ({
  xsSize,
  mdSize,
  lgSize,
  title,
  forceTopSellers,
  lightTheme,
  place,
  slidesToShow,
  forceBundle,
  forceBundleType,
  showfakeCards,
  lazyLoadCover,
  cachedHits,
  hitCardNameTag,
  headingTag,
  hideTitle,
  franchises,
  smSize,
  productPage,
  sliderSettings,
}) => {
  const { hits } = useProductRecommendations({
    forceTopSellers,
    forceBundle,
    forceBundleType,
    cachedHits,
  });

  return (
    <Recommendations
      hits={hits?.slice(0, 12)}
      franchises={franchises}
      xsSize={xsSize}
      smSize={smSize}
      mdSize={mdSize}
      lgSize={lgSize}
      title={title}
      lightTheme={lightTheme}
      place={place}
      slidesToShow={slidesToShow}
      showfakeCards={showfakeCards}
      lazyLoadCover={lazyLoadCover}
      cachedHits={cachedHits}
      hitCardNameTag={hitCardNameTag}
      headingTag={headingTag}
      hideTitle={hideTitle}
      productPage={productPage}
      sliderSettings={sliderSettings}
    />
  );
};

ProductRecommendations.propTypes = {
  xsSize: PropTypes.number,
  smSize: PropTypes.number,
  mdSize: PropTypes.number,
  lgSize: PropTypes.number,
  title: PropTypes.string,
  forceTopSellers: PropTypes.bool,
  lightTheme: PropTypes.bool,
  place: PropTypes.string,
  slidesToShow: PropTypes.number,
  forceBundle: PropTypes.bool,
  forceBundleType: PropTypes.oneOf(['game', 'software', 'book']),
  showfakeCards: PropTypes.bool,
  lazyLoadCover: PropTypes.bool,
  cachedHits: PropTypes.bool,
  hitCardNameTag: PropTypes.string,
  headingTag: PropTypes.string,
  hideTitle: PropTypes.bool,
  productPage: PropTypes.bool,
  sliderSettings: PropTypes.shape({}),
};

ProductRecommendations.defaultProps = {
  xsSize: 6,
  smSize: 6,
  mdSize: 4,
  lgSize: 3,
  title: '',
  forceBundle: false,
  forceBundleType: 'game',
  forceTopSellers: false,
  lightTheme: false,
  place: '',
  slidesToShow: 4,
  showfakeCards: false,
  lazyLoadCover: true,
  cachedHits: false,
  hitCardNameTag: 'div',
  headingTag: 'h2',
  hideTitle: false,
  productPage: false,
  sliderSettings: {},
};

export default ProductRecommendations;
